export class TotemLoginRequest{
    public idTotem: number | null = null;
    
    public ip: string = '';
    public pin: string = '';
}